import { combineReducers } from 'redux';
import { DASHBOARD } from '../actions/types';
import { isLoadingReducer, loadedQueryReducer } from './helpers';

const data = (state = null, action) => {
  switch (action.type) {
    case DASHBOARD.SUCCESS: {
      const { response } = action.payload;
      return response;
    }
    default:
      return state;
  }
};

const loadedQuery = loadedQueryReducer(DASHBOARD);
const isLoading = isLoadingReducer(DASHBOARD);

export default combineReducers({
  data,
  isLoading,
  loadedQuery,
});



// WEBPACK FOOTER //
// ./src/reducers/dashboard.js